import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, ClipboardList, HardHat } from 'lucide-react'
import { cn } from '@/lib/utils'

const navItems = [
  { title: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { title: 'Work Orders', href: '/work-orders', icon: ClipboardList },
  { title: 'My Crew Week', href: '/portal/crew', icon: HardHat },
]

export function MobileNav() {
  const location = useLocation()

  return (
    <nav className="z-50 shrink-0 border-t bg-background pb-safe lg:hidden">
      <div className="flex items-center justify-around">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.href ||
            location.pathname.startsWith(item.href + '/')

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'flex flex-1 flex-col items-center gap-1 py-2 text-xs font-medium transition-colors',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.title}</span>
            </Link>
          )
        })}

      </div>
    </nav>
  )
}
